module.exports = __webpack_public_path__ + "static/media/personFront.5b7f3c3f.png";